import { bannerSagas } from '@store/features/banner/saga';
import { bookingSagas } from '@store/features/booking/saga';
import { doctorSagas } from '@store/features/doctor/saga';
import { faqSagas } from '@store/features/faq/saga';
import { patientSagas } from '@store/features/patient/saga';
import { paymentSagas } from '@store/features/payment/saga';
import { reduxModalsSagas } from '@store/features/redux_modal/saga';
import { resourceSagas } from '@store/features/resource/saga';
import { scheduleSagas } from '@store/features/schedule/saga';
import { serviceSagas } from '@store/features/service/saga';
import { subjectSagas } from '@store/features/subject/saga';
import { telemedSagas } from '@store/features/telemedicine/saga';
import { totalSagas } from '@store/features/total/saga';
import { AppState } from '@store';
import { all, fork } from 'redux-saga/effects';
import { serviceObjectSagas } from '@store/features/service_object/saga';

export default function* rootSaga(): Generator {
  yield all([
    fork(scheduleSagas),
    fork(totalSagas),
    fork(bookingSagas),
    fork(bannerSagas),
    fork(resourceSagas),
    fork(serviceSagas),
    fork(patientSagas),
    fork(doctorSagas),
    fork(paymentSagas),
    fork(faqSagas),
    fork(telemedSagas),
    fork(reduxModalsSagas),
    fork(subjectSagas),
    fork(serviceObjectSagas),
  ]);
}

export const sSelect = (state: AppState) => state;
